<ng-container *transloco="let t;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title" id="deleteSchemaDialogLabel">{{t("schema.deleteschema.title")}}</h2>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p class="m-0">{{ t("schema.deleteschema.text") }}</p>
            </div>
            <div class="modal-footer">
                <ng-container *ngIf="!isSchemaDeleting(); else loadingState">
                    <button class="btn wp-btn-outline" data-bs-dismiss="modal">
                        {{ t("schema.deleteschema.back") }}
                    </button>
                    <button class="btn btn-danger" type="submit" data-bs-dismiss="modal" (click)="onDeleteSchemaClick()">
                        <svg class="icon icon-dark-bg icon-sm">
                            <use xlink:href="assets/icons.svg#icon-delete"></use>
                        </svg>
                        {{ t("schema.deleteschema.delete")}}
                    </button>
                </ng-container>
            </div>
        </div>
    </div>

    <ng-template #loadingState>
        <loading-spinner-border size="md" />
    </ng-template>

</ng-container>